module.exports = __webpack_public_path__ + "static/media/checkCircle.5eef2a1d.svg";